module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "bookingConfirmation"
    }
  }, [_c('div', {
    staticClass: "ui white raised top attached padded segment",
    staticStyle: {
      "color": "#000000"
    }
  }, [_c('div', {
    staticClass: "ui grid"
  }, [_c('div', {
    staticClass: "nine wide column",
    staticStyle: {
      "border-right": "1px solid #e8e8e8"
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.createdReservation.contact.title) + " " + _vm._s(_vm.createdReservation.contact.firstName) + " " + _vm._s(_vm.createdReservation.contact.lastName))]), _vm._v(" "), _c('p', [(_vm.createdReservation.contact.company) ? _c('span', [_vm._v(_vm._s(_vm.$t('Company')) + ": " + _vm._s(_vm.createdReservation.contact.company)), _c('br')]) : _vm._e(), _vm._v("\n          " + _vm._s(_vm.$t('Email')) + ": " + _vm._s(_vm.createdReservation.contact.email)), _c('br'), _vm._v("\n          " + _vm._s(_vm.$t('Telephone')) + ": " + _vm._s(_vm.createdReservation.contact.tel)), _c('br'), _vm._v("\n          " + _vm._s(_vm.$t('Address')) + ": " + _vm._s(_vm.createdReservation.contact.address)), _c('br'), _vm._v("\n          " + _vm._s(_vm.$t('City')) + ": " + _vm._s(_vm.createdReservation.contact.city) + ", " + _vm._s(_vm.createdReservation.contact.zip) + "\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          " + _vm._s(_vm.$t('People')) + ": "), _c('strong', [_vm._v(_vm._s(_vm.createdReservation.people))])])]), _vm._v(" "), _c('div', {
    staticClass: "seven wide column center aligned middle aligned"
  }, [_c('h3', [_c('strong', [_vm._v(_vm._s(_vm.createdReservation.code))])]), _vm._v(" "), _c('div', [_vm._v("Reservation Code")])])])]), _vm._v(" "), _c('table', {
    staticClass: "ui bottom attached basic white table",
    staticStyle: {
      "background": "#ffffff"
    }
  }, [_c('tbody', [_vm._l((_vm.createdReservation.bookings), function(booking) {
    return _c('tr', [_c('td', [_vm._v("\n        " + _vm._s(booking.boat.name) + "\n      ")]), _vm._v(" "), _c('td', [_vm._v("\n        " + _vm._s(booking.hour) + " h\n      ")]), _vm._v(" "), _c('td', [_vm._v("\n        " + _vm._s(_vm.moment(booking.date).format('ll')) + "\n      ")]), _vm._v(" "), _c('td', {
      staticClass: "right aligned"
    }, [_vm._v("\n        €" + _vm._s(booking.cost) + ".00\n      ")])])
  }), _vm._v(" "), (_vm.createdReservation.discount) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('strong', [_vm._v("Voucher:")]), _vm._v(" " + _vm._s(_vm.createdReservation.discount.voucher))])]) : _vm._e(), _vm._v(" "), (_vm.createdReservation.discount && _vm.createdReservation.discount.absolute > 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "right aligned"
  }, [_vm._v("- €" + _vm._s(_vm.createdReservation.discount.absolute) + ".00")])]) : _vm._e(), _vm._v(" "), (_vm.createdReservation.discount && _vm.createdReservation.discount.percentage > 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "right aligned"
  }, [_vm._v("- " + _vm._s(_vm.createdReservation.discount.percentage * 100) + "%")])]) : _vm._e()], 2), _vm._v(" "), _c('tr', [_vm._m(0), _vm._v(" "), _c('td', {
    staticClass: "right aligned"
  }, [_c('strong', [_vm._v("€" + _vm._s(_vm.numeral(_vm.createdReservation.cost).format('0,0.00')))])])]), _vm._v(" "), (_vm.createdReservation.services.length > 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('Additional Services')))])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.createdReservation.services), function(service) {
    return (service.selected) ? _c('tr', [_c('td', {
      attrs: {
        "colspan": "3"
      }
    }, [_vm._v("\n        " + _vm._s(service.title))]), _vm._v(" "), _c('td', {
      staticClass: "right aligned"
    }, [(service.priceType === 'perPerson') ? _c('span', [_vm._v("p.P. €" + _vm._s(_vm.numeral(service.price).format('0,0.00')))]) : _c('span', [_vm._v("€" + _vm._s(_vm.numeral(service.price).format('0,0.00')))])])]) : _vm._e()
  }), _vm._v(" "), (_vm.createdReservation.wishes) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('Additional Wishes')))])])]) : _vm._e(), _vm._v(" "), (_vm.createdReservation.wishes) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.createdReservation.wishes) + "\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.createdReservation.questions) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('Questions')))])])]) : _vm._e(), _vm._v(" "), (_vm.createdReservation.questions) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.createdReservation.questions) + "\n      ")])]) : _vm._e()], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('strong', [_vm._v("Total")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-281b3d90"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/booking/BookingConfirmation.vue
// module id = 735
// module chunks = 1